import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgLightning = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M3 8.886a.48.48 0 0 0 .142.351q.143.135.369.136h4.01l-2.115 5.803q-.106.279-.043.48.072.2.235.286a.49.49 0 0 0 .376.036.72.72 0 0 0 .39-.272l6.452-8.138Q13 7.332 13 7.11a.46.46 0 0 0-.142-.344.5.5 0 0 0-.369-.144h-4.01L10.594.82q.106-.273.036-.473a.46.46 0 0 0-.235-.286.5.5 0 0 0-.376-.043q-.206.05-.383.279l-6.451 8.13Q3 8.672 3 8.888"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLightning);
export default ForwardRef;
